<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import useSitemap from "@/composables/useSitemap";

const emit = defineEmits(['close']);

const {updateAutoAssignStatusMutation} = useSitemap();

const {mutate: updateAutoAssignStatus} = updateAutoAssignStatusMutation;

const handleStartFresh = () => {
  updateAutoAssignStatus({
    reset_sitemap: true,
  });
  emit('close');
}
const handleAddToExisting = () => {
  updateAutoAssignStatus({
    reset_sitemap: false,
  });
  emit('close');
}

</script>

<template>
  <teleport to=".tailwind">
    <BaseModal @close="() => emit('close')">
      <div class="tw-flex tw-flex-col tw-gap-4">
        <h3 class="tw-text-2xl tw-font-medium">
          Automatically Assign Your Keywords
        </h3>

        <p>
          We’re about to review your website to match your selected keywords with the most relevant pages. This helps
          ensure your SEO is set up in the best possible way.
        </p>

        <p>
          Since you’ve already assigned some keywords to pages, please let us know how you’d like to proceed:
        </p>
        <ul>
          <li>Start fresh: Clear all previous keyword assignments and begin again.</li>
          <li>Add to existing: Keep your current assignments and only assign any unassigned keywords.</li>
        </ul>

        <p>
          Choose an option below to continue:
        </p>

        <div class="tw-flex tw-gap-4">
          <DefaultButton @click="handleStartFresh">
            Start Fresh
          </DefaultButton>

          <DefaultButton @click="handleAddToExisting">
            Add to Existing
          </DefaultButton>
        </div>
      </div>
    </BaseModal>
  </teleport>
</template>
